export default {
  maxFilesize: 1000,
  timeout: 0
};
